import React from 'react';

const ModalButton = ({text, onClick, disabled, showBail, bail}) => {

	return <>
		<button className="modal-button" onClick={onClick} disabled={disabled}>{text}</button>
		{showBail && <button className="modal-bail-button" onClick={bail}>Maybe Later</button>}
	</>
}

export default ModalButton;